// extracted by mini-css-extract-plugin
export default {"heading":"ImpressumContent_heading__Kpn-u","team":"ImpressumContent_team__chHmj"};